import { msg } from '@lit/localize';

export interface RuntimeValueDraftItem {
  id: string;
  key: string;
  value?: string;
}

export interface RuntimeValueDraft {
  id: string;
  key: string;
  value: string;
  valueTouched: boolean;
}

const RUNTIME_VALUE_KEY_PATTERN = /^[A-Za-z0-9_.-]+$/;

export function normalizeRuntimeValueKey(key: string): string {
  return key.trim();
}

export function validateRuntimeValueDraft(
  draft: RuntimeValueDraft,
  items: RuntimeValueDraftItem[],
  options: {
    currentId?: string;
    newDraft?: RuntimeValueDraft | null;
    reservedKeys?: string[];
  } = {}
): string {
  const key = normalizeRuntimeValueKey(draft.key);
  if (!key) {
    return msg('Key is required.');
  }
  if (!RUNTIME_VALUE_KEY_PATTERN.test(key)) {
    return msg(
      'Key may only contain letters, numbers, dots, underscores, and hyphens.'
    );
  }
  if (
    items.some(
      (item) =>
        item.id !== options.currentId &&
        normalizeRuntimeValueKey(item.key) === key
    )
  ) {
    return msg('Key already exists.');
  }
  if (
    options.newDraft &&
    options.newDraft.id !== options.currentId &&
    normalizeRuntimeValueKey(options.newDraft.key) === key
  ) {
    return msg('Key already exists.');
  }
  if (
    options.reservedKeys?.some(
      (reservedKey) => normalizeRuntimeValueKey(reservedKey) === key
    )
  ) {
    return msg('Key already exists.');
  }
  return '';
}

export function isRuntimeValueDraftDirty(
  item: RuntimeValueDraftItem,
  draft: RuntimeValueDraft
): boolean {
  return (
    normalizeRuntimeValueKey(draft.key) !== item.key ||
    (draft.valueTouched && draft.value !== (item.value ?? ''))
  );
}
